export default "__VITE_ASSET__BzC90VMA__"